/**
 * A due date as people read it (« 9 oct. », with the year only when it is not
 * the current one), and whether it is past. Invalid dates are shown as given.
 */
export const formatDueDate = (value: string, now: Date = new Date()): { label: string; overdue: boolean } => {
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value);
  if (Number.isNaN(date.getTime())) return { label: value, overdue: false };
  const sameYear = date.getFullYear() === now.getFullYear();
  const label = date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return { label, overdue: date.getTime() < today.getTime() };
};
